import Select from './Select.vue';

export default Select;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/form/components/select/index.ts